export class Feedback{
  titulo: string;
  texto: string;
  usuario: string;
  dataCadastro: Date;
  usuarioId: number;
}
